export default __webpack_public_path__ + "static/media/settle-2.93968177.png";